import React, { useState } from "react";
import EventItem from "./EventItem";
import Modal from "components/UI/Modal";
import EventPopup from "./EventPopup";
import EventLisstSkeleton from "./skeleton/EventListSkeleton";
import ScrollContent from "components/UI/ScrollContent";
import placeholder360x225 from "assets/placeholder/360x225.png";
import { useSelector } from "react-redux";
import { filterByKey, filterBySearch } from "utils/utils";
import playClickSpecial from "utils/playClickSpecial";

const EventList = ({ events, loading, apiPath, titleButton, noEvent }) => {
  const floorState = useSelector((state) => state.filter.filterByFloor);
  const searchState = useSelector((state) => state.filter.filterByName);
  const [modalOpen, setModalOpen] = useState(0);
  const [eventCode, seteventCode] = useState(0);

  if (!events || loading) {
    return <EventLisstSkeleton />;
  }

  if (searchState) {
    events = filterBySearch(events, "title", searchState);
  }

  if (floorState) {
    events = filterByKey(events, "floor_id", floorState.id);
  }

  const openModal = (id, code) => {
    playClickSpecial();
    setModalOpen(id);
    seteventCode(code);
  };

  const closeModal = () => {
    playClickSpecial();
    setModalOpen(false);
  };

  return (
    <ScrollContent mr={20}>
      <div className="row kiosk-row">
        {events.length ? events.map((event, index) => {
          return (
            <div className="col-6" key={index}>
              <EventItem
                id={event.id}
                title={event.title}
                img={event.thumb || placeholder360x225}
                open={() => openModal(event.id, event.code)}
              />
            </div>
          );
        }):  <p className="font-weight-bold ml-2">{noEvent}</p> }
      </div>
      <Modal show={modalOpen ? true : false} close={closeModal}>
        <EventPopup apiPath={apiPath} id={modalOpen} code={eventCode} titleButton={titleButton}/>
      </Modal>
    </ScrollContent>
  );
};

export default EventList;
